export default "__VITE_ASSET__Bxj81X_3__"